module.exports = __webpack_public_path__ + "database-development.1_rVy_Eh.svg";